import { InjectionToken } from '@angular/core';
import { webSocket } from 'rxjs/webSocket';

export const WEBSOCKET_FACTORY = new InjectionToken<typeof webSocket>('WebSocketFactory', {
  providedIn: 'root',
  factory: () => webSocket,
});
